export default "/img/hero/code.png"